<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { PACKAGE, HOTEL_ONLY, AIR_ONLY, CRUISE, INCENTIVES } from '@/constants';
import Button from 'primevue/button';
import Tab from 'primevue/tab';
import TabList from 'primevue/tablist';
import TabPanel from 'primevue/tabpanel';
import TabPanels from 'primevue/tabpanels';
import Tabs from 'primevue/tabs';
import TermsAndConditionsEditor from '@/components/termsAndConditions/TermsAndConditionsEditor.vue';

const props = defineProps<{
  listData: object;
  typeForm: string;
}>();

const emits = defineEmits<{
  handleSubmit: [value: any];
  'update:listData': [value: any];
}>();

const { t } = useI18n({ useScope: 'global' });

const listTermAndConditions = computed({
  get() {
    return props.listData;
  },
  set(value) {
    emits('update:listData', value);
  }
});

const getHeader = (qType: string) => {
  switch (qType) {
    case PACKAGE:
      return t('common.package');
    case HOTEL_ONLY:
      return t('common.hotel');
    case AIR_ONLY:
      return t('common.air');
    case CRUISE:
      return t('common.cruise');
    case INCENTIVES:
      return t('common.incentives');
    default:
      return t('menu.tours');
  }
};

const replaceBrTags = (rules: any) => {
  const newObj: any = {};
  for (const key in rules) {
    if (typeof rules[key] === 'string') {
      newObj[key] = rules[key].replace(/<br>/g, '<br/>');
    } else {
      newObj[key] = rules[key];
    }
  }

  return newObj;
};

const handleSubmit = (submitData: any) => {
  emits('handleSubmit', replaceBrTags(submitData));
};
</script>
<template>
  <div class="tabs-term-conditions">
    <Tabs :value="0">
      <TabList>
        <Tab v-for="(item, index) in listTermAndConditions" :key="index" :value="index">{{ getHeader(item.qType) }}</Tab>
      </TabList>
      <TabPanels>
        <TabPanel v-for="(item, index) in listTermAndConditions" :key="index" :value="index">
          <TermsAndConditionsEditor :item="item" :typeForm="typeForm"></TermsAndConditionsEditor>
          <div class="text-center mt-5">
            <Button :label="$t('promos.save')" icon="pi pi-check" class="mr-2 bg-primary save-btn" @click="handleSubmit(item)" />
          </div>
        </TabPanel>
      </TabPanels>
    </Tabs>
  </div>
</template>
<style lang="scss" scoped>
:deep() {
  .custom-editor {
    .ql-container {
      height: 320px;
    }
  }
}
</style>
